import ApiResource from '@/api/ApiResource';
import { MemoruHomeResourceDownloadResponse } from 'chaild-entity/src/component/memoruHome/resource/types';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export const insertStr = (str: string, index: number, insert: string) => {
  return str.slice(0, index) + insert + str.slice(index, str.length);
}

export const formatAmzIso = (dateStr: string): string => {
  let formatted = dateStr;
  formatted = insertStr(formatted, 4, '-');
  formatted = insertStr(formatted, 7, '-');
  formatted = insertStr(formatted, 13, ':');
  formatted = insertStr(formatted, 16, ':');
  return formatted;
}

export const checkPresignedUrlExpired = async ({ url, objectKey }: {
  url: string,
  objectKey: string
}): Promise<MemoruHomeResourceDownloadResponse> => {
  const arr = url.split(/[=&]/);
  if (arr.length >= 12) {
    const XAmzDate = dayjs(formatAmzIso(arr[5])).locale('ja');
    const XAmzExpires = Number(arr[7]);
    const ExpirationTime = dayjs(XAmzDate).add(XAmzExpires, 'seconds');
    const Now = dayjs();
    const isExpired = Now.isAfter(ExpirationTime);
    if (isExpired) {
      const response = await ApiResource.postResourceDownload({ objectKey })
      return response
    }
  }

  return {
    preSignedUrl: url,
    preSignedDownloadUrl: url
  }
}
